module.exports = __webpack_public_path__ + "18d7604dea329de82a22b8c2a727e216.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-12.png
// module id = 1165
// module chunks = 0